/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import Acceso, { rutasAcceso } from "./components/Acceso";
import "./index.css";

const elem = document.getElementById("root")!;
const ruta = window.location.pathname;
const app = (
  <StrictMode>
    {rutasAcceso.includes(ruta) ? <Acceso ruta={ruta} /> : <App />}
  </StrictMode>
);

// https://bun.com/docs/bundler/hot-reloading#import-meta-hot-data
(import.meta.hot.data.root ??= createRoot(elem)).render(app);
